import * as Stacktrace from "stacktrace-js";
// import GoogleAnalytics from "react-ga";
import store from "../redux";
import { detect } from "detect-browser";
import * as Sentry from "@sentry/browser";

const info = require("../version.json");

export const getUiVersion = () => {
  return info.version;
};
// Backend errorCodes that are routine user/UI conditions, not bugs. Drop them
// before they hit Sentry so the noise doesn't drown the real signal:
//   1027 INVALID_PASSWORD              — wrong password on login
//   1031 NO_VALID_SUBSCRIPTION         — gate prompt, not a bug
//   1034 OUT_OF_CREDITS                — paywall/credit refill flow
//   1042 FEATURE_NOT_INCLUDED_IN_PLAN  — plan upsell prompt
//   1047 INVALID_EMAIL_ADDRESS         — form validation
//   1056 EMAIL_ALREADY_REGISTERED      — signup collision
//   1064 PASSWORD_PROTECTED_PDF...     — user-facing upload notice
//   1092 TOKEN_NOT_FOUND               — expired reset/confirm link
const BENIGN_BACKEND_ERROR_CODES = new Set([
  1027, 1031, 1034, 1042, 1047, 1056, 1064, 1092,
]);

export const logErrorToGA = (err, fatal = false) => {
  // `window.onerror` often has `event.error === null` (e.g. script load/CORS). Sending that to Sentry
  // creates synthetic issues titled "<unknown>" with message "null" and no stack.
  if (err == null) {
    return;
  }
  const errCode = (err as any)?.errorCode;
  if (typeof errCode === "number" && BENIGN_BACKEND_ERROR_CODES.has(errCode)) {
    return;
  }
  // Promise rejections with no payload — typically aborted XHRs, canceled
  // fetches, or libraries that `reject({})` on user-cancel. They serialize
  // to `Error: {}` and group as DOCUCLIPPER-36Y with no useful stack.
  if (
    !(err instanceof Error) &&
    typeof err === "object" &&
    err !== null &&
    Object.keys(err).length === 0
  ) {
    return;
  }
  let serialized: string | undefined;
  if (!(err instanceof Error)) {
    serialized = typeof err === "string" ? err : JSON.stringify(err);
    // Values like NaN, {toJSON: () => null}, empty objects/strings serialize
    // to "null" / "{}" / '""' / "" and yield an Error with no stack — these
    // all group under one useless fingerprint (DOCUCLIPPER-... 90k/day).
    if (
      serialized === undefined ||
      serialized === "" ||
      serialized === "null" ||
      serialized === "{}" ||
      serialized === '""'
    ) {
      return;
    }
  }
  const errForSentry =
    err instanceof Error ? err : new Error(serialized);

  const browser = detect();
  const browserName = browser ? browser.name : "";
  const browserVersion = browser ? browser.version : "";
  const browserOs = browser ? browser.os : "";
  const token = store.getState().Auth.token;
  let userId: number | null = null;
  if (token && token.user !== undefined) {
    userId = token.user;
    if (process.env.NODE_ENV === "production") {
      Sentry.addBreadcrumb({
        data: {
          userId,
        },
      });
    }
  }

  if (process.env.NODE_ENV === "production") {
    Sentry.captureException(errForSentry);
  }
  Stacktrace.fromError(errForSentry)
    .then((stackframes) => {
      const description = `${stackframes.join("\n")}\n\n${JSON.stringify({
        version: info.version,
        sha: info.sha,
        userId,
        browserName,
        browserVersion,
        browserOs,
      })}`;

      // GoogleAnalytics.exception({
      //   description: description.replace(/@/g, ""),
      //   fatal: false,
      // });
    })
    .catch((err) => {
      const description = `${err.stack}\n\n${JSON.stringify({
        version: info.version,
        sha: info.sha,
        userId,
        browserName,
        browserVersion,
        browserOs,
      })}`;
      // GoogleAnalytics.exception({
      //   description: description.replace(/@/g, ""),
      //   fatal: false,
      // });
    });
};
